import React from 'react'

import {useToastController} from '@vio/atlas/context/toastController'
import {Link} from '@vio/atlas/Link'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

export const FROZEN_DEAL_PARAM = 'frozenDeal'

interface MessageProps {
  myBookingsUrl: string
}

const Message: React.FC<MessageProps> = ({myBookingsUrl = ''}) => (
  <div>
    <Text variant="bodyS">
      <FormattedMessageWrapper
        id="dealFreeze.dealFrozenAndSaved"
        defaultMessage="Deal frozen and saved to <MyBookings></MyBookings>"
        values={{
          MyBookings: () => (
            <Link variant="inverse" href={myBookingsUrl}>
              <FormattedMessageWrapper
                id="myBookings"
                defaultMessage="My bookings"
              />
            </Link>
          )
        }}
      />
    </Text>
  </div>
)

interface Props {
  myBookingsUrl: string
}

// useFrozenDealToast hook encapsulates the logic for showing and hiding the frozen deal toast that
// is shown on the DealFreeze confirmation overlay and on the SRP.
export const useFrozenDealToast = ({myBookingsUrl}: Props) => {
  const {open, close} = useToastController()

  const showFrozenDealToast = () =>
    open(<Message myBookingsUrl={myBookingsUrl} />, {
      showCloseButton: true,
      singleToastMessage: true,
      autoClose: false,
      closeOnOutsideClick: true
    })

  const closeFrozenDealToast = () => close()

  return {
    showFrozenDealToast,
    closeFrozenDealToast
  }
}
